/* This is generated code, don't alter */
var IfcActuatorTypeEnum;
(function (IfcActuatorTypeEnum) {
    IfcActuatorTypeEnum[IfcActuatorTypeEnum["ELECTRICACTUATOR"] = 0] = "ELECTRICACTUATOR";
    IfcActuatorTypeEnum[IfcActuatorTypeEnum["HANDOPERATEDACTUATOR"] = 1] = "HANDOPERATEDACTUATOR";
    IfcActuatorTypeEnum[IfcActuatorTypeEnum["HYDRAULICACTUATOR"] = 2] = "HYDRAULICACTUATOR";
    IfcActuatorTypeEnum[IfcActuatorTypeEnum["PNEUMATICACTUATOR"] = 3] = "PNEUMATICACTUATOR";
    IfcActuatorTypeEnum[IfcActuatorTypeEnum["THERMOSTATICACTUATOR"] = 4] = "THERMOSTATICACTUATOR";
    IfcActuatorTypeEnum[IfcActuatorTypeEnum["USERDEFINED"] = 5] = "USERDEFINED";
    IfcActuatorTypeEnum[IfcActuatorTypeEnum["NOTDEFINED"] = 6] = "NOTDEFINED";
})(IfcActuatorTypeEnum || (IfcActuatorTypeEnum = {}));
const IfcActuatorTypeEnumCount = 7;
export { IfcActuatorTypeEnum, IfcActuatorTypeEnumCount };
/* This is generated code, don't alter */
import MinimalPerfectHash from "../../indexing/minimal_perfect_hash.js";
let gMapIfcActuatorTypeEnum = new Int32Array([175]);
let prefixSumAddressIfcActuatorTypeEnum = new Uint32Array([0, 13, 32, 51, 73, 85, 107, 125]);
let slotMapIfcActuatorTypeEnum = new Int32Array([5, 3, 2, 4, 6, 1, 0]);
let encodedDataIfcActuatorTypeEnum = (new TextEncoder()).encode(".USERDEFINED..PNEUMATICACTUATOR..HYDRAULICACTUATOR..THERMOSTATICACTUATOR..NOTDEFINED..HANDOPERATEDACTUATOR..ELECTRICACTUATOR.");
let IfcActuatorTypeEnumSearch = new MinimalPerfectHash(gMapIfcActuatorTypeEnum, prefixSumAddressIfcActuatorTypeEnum, slotMapIfcActuatorTypeEnum, encodedDataIfcActuatorTypeEnum);
export { IfcActuatorTypeEnumSearch };
/* This is generated cold, don't alter */
import StepEnumParser from "../../step/parsing/step_enum_parser.js";
const parser = StepEnumParser.Instance;
export function IfcActuatorTypeEnumDeserializeStep(input, cursor, endCursor) {
    return parser.extract(IfcActuatorTypeEnumSearch, input, cursor, endCursor);
}
